import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PaymentList.scss';

const CARD_PROPERTIES = {
  number: 'Card Number',
  type: 'Card Type',
  expiry: 'Expiry Date',
};

function PaymentList({ card, vip }) {
  const paymentList = Object.entries(card).map(entry => (
    <li key={entry[0]} className={styles.item}>
      <span
        className={classNames(styles.cell, styles.label)}
      >
        { CARD_PROPERTIES[entry[0]] }
      </span>
      <span
        className={classNames(styles.cell, styles.value)}
      >
        { vip ? ' ' : entry[1] }
      </span>
    </li>
  ));
  return (
    <ul className={styles.root}>{paymentList}</ul>
  );
}

PaymentList.propTypes = {
  vip: PropTypes.bool.isRequired,
};

export default PaymentList;
